import { NgModule } from '@angular/core';
import { ContactsListComponent } from './contacts-list';
import { IonicModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
      ContactsListComponent,
  ],
    imports: [
    CommonModule,
    IonicModule
  ],

  exports: [
      ContactsListComponent
  ]
})
export class ContactsListComponentModule {}


// WEBPACK FOOTER //
// ./src/components/contacts-list/contacts-list.module.ts